import ReactDOM from "react-dom/client";

window.onload = function () {
  import("./Nabu.jsx").then(({ default: Nabu }) => {
    const pageRoot = document.getElementById("nabu");

    if (!pageRoot.shadowRoot) {
      const shadowRoot = pageRoot.attachShadow({ mode: "open" });

      const shadowContainer = document.createElement("div");
      shadowRoot.appendChild(shadowContainer);

      // en la carpeta public crear una hoja de estilos e insertarla aca creando una etiqueta link, va a ser un archivo unico pero será mas intituivo el desarrollo, se me ocurre eso como solucion temporal M.Elsesser 18-03-2025
      const styleElement = document.createElement("style");
      styleElement.textContent = `
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css");
      `;
      shadowRoot.appendChild(styleElement);

      const locked = false;
      const language = pageRoot.getAttribute("language");
      const client_domain = pageRoot.getAttribute("client_domain");
      const token = pageRoot.getAttribute("token");
      const configurationId = pageRoot.getAttribute("configurationId");

      // renderizar la app dentro del shadow dom
      const root = ReactDOM.createRoot(shadowContainer);
      root.render(
        <Nabu
          locked={locked}
          language={language}
          token={token}
          client_domain={client_domain}
          configurationId={configurationId}
          shadowRoot={shadowRoot} // lo pasamos como prop para poder asignarle estilos
        />
      );
    }
  });
};



{/* <div
	token="5137da94d3e5a9b57a11deadb04f6d641d18e11adb5264cf3465de027a11a96" client_domain="U2FsdGVkX1+OBzknMnzcAviz5eEFaYmIl6O5W7pEg0+9AgR6vQwLsW9KLQk5cQ4H"
	configurationId="aeb3896523dc0aa7bd209e0f5b394d2c"
	id="nabu"
	language="es">
</div>
<link
	href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;0,1000;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900;1,1000&display=swap"
	rel="stylesheet">
<script defer="defer" src="https://sandbox.atenea.ai/nabu/static/js/main.nabuSnippet.js
"></script> */}